import React from "react";
import { AvailabilityType } from "@clockwise/schema";
import { OfflineBolt } from "@material-ui/icons";
import { Shield } from "@components/svgs/Shield";
import { Balanced } from "@components/svgs/Balanced";

export const AVAILABILITY_TEXT: { [type in AvailabilityType]: string } = {
  [AvailabilityType.MaximizeAvailability]: "Maximize availability",
  [AvailabilityType.BalanceAvailabilityAndFocus]: "Balance availability and Focus Time",
  [AvailabilityType.MaximizeFocusTime]: "Protect Focus Time",
};

export const AVAILABILITY_TEXT_SHORT: { [type in AvailabilityType]: string } = {
  [AvailabilityType.MaximizeAvailability]: "Maximize availability",
  [AvailabilityType.BalanceAvailabilityAndFocus]: "Balance availability",
  [AvailabilityType.MaximizeFocusTime]: "Protect Focus Time",
};

export const AVAILABILITY_ICON: { [type in AvailabilityType]: JSX.Element } = {
  [AvailabilityType.MaximizeAvailability]: <OfflineBolt />,
  [AvailabilityType.BalanceAvailabilityAndFocus]: <Balanced />,
  [AvailabilityType.MaximizeFocusTime]: <Shield />,
};
